import { IEntity } from '@pf/shared-common';
import {
    InventoryAdjustmentReason,
    InventoryAdjustmentSearchRequestParams,
    InventoryAdjustmentType,
    InventoryAdjustmentViewModelRead,
    InventoryAdjustmentViewModelUpdateBody,
    InventoryBundleFragment,
    ResourceAuth,
    WmsPlatformEntity,
} from '@control-tower/platform-wms';
import { CustomFieldDto, IUserFragment } from '@pf/shared/util-platform';

export type InventoryAdjustmentRead = InventoryAdjustmentViewModelRead &
    IEntity;
export type InventoryAdjustmentCreate = InventoryAdjustmentViewModelUpdateBody;
export type InventoryAdjustmentSearchParams =
    InventoryAdjustmentSearchRequestParams;

export class InventoryAdjustmentDto implements IEntity {
    constructor(data: Partial<InventoryAdjustmentDto>) {
        Object.assign(this, data);
    }
    id!: string;
    inventoryBundleId!: string;
    adjustedTotalQuantity!: number;
    readonly absoluteAdjustedTotalQuantity?: number;
    beforeTotalQuantity!: number;
    afterTotalQuantity!: number;
    adjustedReservedQuantity!: number;
    readonly absoluteAdjustedReservedQuantity?: number;
    beforeReservedQuantity!: number;
    afterReservedQuantity!: number;
    adjustedAvailableQuantity!: number;
    readonly absoluteAdjustedAvailableQuantity?: number;
    beforeAvailableQuantity!: number;
    afterAvailableQuantity!: number;
    adjustmentType!: InventoryAdjustmentType;
    adjustmentReason!: InventoryAdjustmentReason;
    sourceEntity?: WmsPlatformEntity;
    sourceEntityId?: string | null;
    exceptionId?: string | null;
    notes?: string | null;
    adjustedByUserId!: string;
    adjustedByUser!: IUserFragment;
    adjustmentPrice?: number | null;
    resourceAuth?: ResourceAuth;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    customFields?: Array<CustomFieldDto> | null;
    inventoryBundle?: InventoryBundleFragment;
}
